"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SyncNetworkError = exports.SyncError = void 0;
/**
 * Generic SyncLibrary error class
 */
class SyncError extends Error {
  constructor(message) {
    let status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    super();
    this.name = this.constructor.name;
    this.message = "".concat(message, " (status: ").concat(status, ", code: ").concat(code, ")");
    this.status = status;
    this.code = code;
  }
}
exports.SyncError = SyncError;
class SyncNetworkError extends SyncError {
  constructor(message) {
    let status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let body = arguments.length > 3 ? arguments[3] : undefined;
    super(message, status, code);
    this.body = body;
  }
}
exports.SyncNetworkError = SyncNetworkError;
exports.default = SyncError;